import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const loadReconciliationFileDeleteAtom = createMutationAtomFactory(
  'trade.loadReconciliationFileDelete',
  (params: { fileId: string }) => ({
    tradeFileDelete: {
      __args: { fileId: params.fileId },
    },
  }),
);
